<template>
  <div class="default-filter-date">
    <v-menu
      ref="menu"
      v-model="menuFilterDate"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="filterDate"
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="formattedFilterDate"
          :label="label"
          append-icon="event"
          width="160px"
          outline
          readonly
          v-on="on"
          @click:append="menuFilterDate = true"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="filterDate"
        :type="kind"
        :min="minDate"
        no-title
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="cleanFilterDate()">{{i18n('Limpar')}}</v-btn>
        <v-btn flat color="primary" @click="selectFilterDate()">OK</v-btn>
      </v-date-picker>
    </v-menu>
    
    <v-menu
      ref="menuTime"
      v-model="menuFilterTime"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <v-time-picker 
        v-model="filterTime"
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="cleanFilterTime()">{{i18n('Limpar')}}</v-btn>
        <v-btn flat color="primary" @click="selectFilterTime()">OK</v-btn>
      </v-time-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'DefaultFilterDate',
  props: {
    callback: {
      type: Function,
      default: () => {}
    },
    kind: {
      type: String,
      default: 'month'
    },
    label: {
      type: String,
      default: 'Data'
    },
    minDate: {
      type: String,
      default: undefined
    },
    useDateUTC: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      filterDate: null,
      filterTime: null,
      responseDateTime: null,
      menuFilterDate: false,
      menuFilterTime: false,
    }
  },
  computed: {
    formattedFilterDate() {
      return this.formatInput()
    },
    formattedFilterTime() {
      return this.formatInput()
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    selectFilterDate() {
      if (this.filterDate !== null) {
        this.menuFilterTime = true
      }
      this.$refs.menu.save(this.filterDate)
      this.$emit('reload', this.filterDate)
    },
    cleanFilterDate() {
      this.filterDate = null
      this.$refs.menu.save(this.filterDate)
      this.$emit('reload', this.filterDate)
      this.$emit('resetFilter')
    },
    selectFilterTime() {
      this.$refs.menuTime.save(this.filterTime)
      this.$emit('reload', this.filterTime)
      this.menuFilterTime = false
    },
    cleanFilterTime() {
      this.filterTime = null
      this.$refs.menuTime.save(this.filterTime)
      this.$emit('reload', this.filterTime)
      this.$emit('resetFilter')
    },
    formatInput() {
      if(this.filterDate === null) {
        return null
      }
      const time = this.filterTime || "00:00"
      const splitted = this.filterDate.split('-')
      const year = Number(splitted[0])
      const month = Number(splitted[1])
      let day = 1
      let day_part = ''
      if (this.kind == 'date') {
        day = Number(splitted[2])
        day_part = String(day).padStart(2, '0') + '/'
      }
      
      let date = new Date(year, month - 1, day)
      
      if (this.filterTime) {
        const splittedTime = this.filterTime.split(':')
        const hour = Number(splittedTime[0])
        const minute = Number(splittedTime[1])
        date.setHours(hour)
        date.setMinutes(minute)
      }
      
      const formattedMonth = date.toLocaleString('default', { month: 'short' });
      
      if (this.filterTime) {
        const newDate = date.toJSON().split('.')[0]
        if (this.responseDateTime !== newDate) {
          this.responseDateTime = newDate
          this.callback(this.responseDateTime)
        }
      }
      
      return `${day_part}${formattedMonth.toUpperCase()}/${year} ${time}`
    },
  }
}
</script>

<style>
.default-filter-date .v-text-field .v-text-field__slot input {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/filters/DefaultFilterDateTime.vue